import { APPLICATION_NAMESPACE, APPLICATION_ID } from './authConstants';

export { b2cPolicies } from './policies';
// signInAuthProvider: static Msal instance
// getSignInAuthProvider: dynamic Msal instance based on the current Locale
// export { signInAuthProvider, getSignInAuthProvider } from './authProvider';
export { signInAuthProvider } from './msalReactAuthProvider';
export { default as getAccessToken } from './getAccessToken';
export { default as CurrentUser } from './currentUser';
export { default as WebsocketClient } from './websocketClient';
// export { default as Authentication } from 'auth/Authentication.ts';

export const loginRequest = {
  scopes: [
    `https://${APPLICATION_NAMESPACE}.onmicrosoft.com/${APPLICATION_ID}/User.Read`
  ]
};
